import classNames from 'classnames';
import Lottie from 'lottie-react';

import './lottie-animation.scss';

import type { LottieRefCurrentProps } from 'lottie-react';

interface LottieAnimationProps {
	animationData: unknown;
	autoplay?: boolean;
	lottieRef?: { current: LottieRefCurrentProps | null };
	className?: string;
	loop?: boolean;
	onComplete?: () => void;
}

const LottieAnimation = ({
	animationData,
	autoplay = true,
	lottieRef,
	className,
	loop,
	onComplete,
}: LottieAnimationProps) => {
	return (
		<Lottie
			animationData={animationData}
			autoplay={autoplay}
			loop={loop}
			className={classNames('lottie-animation', className)}
			lottieRef={lottieRef}
			onComplete={onComplete}
		/>
	);
};

export default LottieAnimation;
